<template>
  <HomeBanner></HomeBanner>
  <TheStatistics></TheStatistics>
  <TheFuture></TheFuture>
  <TheLicense></TheLicense>
  <GlobalPresence></GlobalPresence>
  <GlobalPartnership></GlobalPartnership>
  <EsgBlock></EsgBlock>
  <LatestNews />
  <FutureOpportunity></FutureOpportunity>
  <Modals />
</template>

<script setup>
// @ is an alias to /src
import HomeBanner from '../components/LandingPage/HomeBanner.vue'
import TheStatistics from '../components/LandingPage/TheStatistics.vue'
import TheFuture from '../components/LandingPage/TheFuture.vue'
import TheLicense from '../components/LandingPage/TheLicense.vue'
import GlobalPresence from '../components/LandingPage/GlobalPresence.vue'
import GlobalPartnership from '../components/LandingPage/GlobalPartnership.vue'
import FutureOpportunity from '../components/LandingPage/FutureOpportunity.vue'
import LatestNews from '../components/LandingPage/LatestNews.vue'
import EsgBlock from '../components/LandingPage/ESGBlock.vue'
import Modals from '@/components/Modals/ModalMain.vue'
import { useHead } from '@unhead/vue'
import { useI18n } from 'vue-i18n'
import { computed, onMounted } from 'vue'
import { decodeHtml } from '@/utils'

const { t } = useI18n()

useHead({
  title: computed(() => decodeHtml(t('seo.home.title'))),
  meta: [
    { name: 'description', content: computed(() => t('seo.home.description')) },
    { name: 'keywords', content: computed(() => t('seo.home.keywords')) },
  ],
})

onMounted(() => {
  if (typeof document !== 'undefined')
    document.dispatchEvent(new Event('prerender-ready'))
})
</script>

<style scoped lang="less">
.home-view {
  margin: 0;
  padding: 0;
}
</style>
